import { t } from '@lingui/macro';
import { i18n } from '@lingui/core';
import { isString, map, uniq } from 'lodash';
import moment from 'moment-timezone';
import { createAlertConfig, ERROR } from '../../stores/AlertsStore';

export const yesTranslated = i18n._(t`Yes`);
export const noTranslated = i18n._(t`No`);

export const ID_FIELD = '_id';
export const INTERNAL_ID_FIELD = 'internalId';

export const DEFAULT_VALIDATION_ERROR_TEXT = t`There are validation errors on the page`;

export const errorAlertObject = createAlertConfig(
    ERROR,
    i18n._(t`An error occurred while saving.  Please contact support.`)
);

export const TIME_ZONES = getMomentTimeZones();

function getMomentTimeZones() {
    return map(moment.tz.names(), (name) => {
        const zone = moment.tz.zone(name);
        return {
            name,
            code: name,
            abbrs: uniq(zone.abbrs).join(', '),
        };
    });
}

const momentFormatter = moment();

export function getTimeZoneShortName(timeZone) {
    if (!isString(timeZone)) {
        return '';
    }

    const shortName = momentFormatter.tz(timeZone).format('z');
    if (!shortName) {
        return '';
    }

    return ` (${shortName})`;
}

/**
 * Used for auto-complete inputs
 */
export function getTimeZoneOptions() {
    return map(TIME_ZONES, (option) => {
        option.pretty = `${option.code}${getTimeZoneShortName(option.code)}`;
        return option;
    });
}
